@if (title) {
  <app-dynamic-data-list-header>
    <div style="display: flex; justify-content: space-between">
      <h4>{{ getTitle(title) | translate}}</h4>
      <div style="display: flex; justify-content: space-between">
        <div class="d-flex align-items-baseline search-wrapper">
          <div class="menu-wrapper btn btn-secondary btn-link mr-3" (click)="onClickSearchIcon()" [hidden]="showSearch">
            <span>
              <i class="now-ui-icons ui-1_zoom-bold"></i>
            </span>
          </div>
          <div class="search-input-group input-group text-nowrap mr-2"
            [hidden]="!showSearch"
            [class.expand]="animateSearch">
            <input type="search"
              class="form-control"
              #search
              (keydown.enter)="searchSubmit(search.value)" />
              <div class="input-group-append">
                <button type="button" class="input-group-text" (click)="searchSubmit(search.value)">
                  <i class="now-ui-icons ui-1_zoom-bold"></i>
                </button>
              </div>
            </div>
          </div>
          <app-download-csv-menu [cellProps]="cellProps" [items]="displayItems" [filename]="getTitle(title)"></app-download-csv-menu>
          <ng-content select="[header]"></ng-content>
        </div>
      </div>
    </app-dynamic-data-list-header>
  }

  <div class="card-body card-list pt-0 pl-3 d-flex justify-content-between flex-column" #tableWrapper>
    <div [class]="'d-table w-100 ' + tableSizeClass">
      @if (!isLoading && allItems?.length) {
        <app-dynamic-data-list-table [items]="displayItems" [cellProps]="cellProps"
          [class]="tableClass">
        </app-dynamic-data-list-table>
      }
      @if (!isLoading && allItems && !allItems.length) {
        <p class="mt-4 ml-3">
          {{ 'NO_RECORDS' | translate }}
        </p>
      }
      @if (isLoading) {
        <div>
          <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
        </div>
      }
    </div>

    @if (pagination) {
      <app-dynamic-data-list-pagination [hidden]="!allItems || isLoading" [totalCount]="totalCount"
        [pageSize]="itemsPerPage" [lazyLoadingPagination]="lazyLoadingPagination" [useUrlParameters]="useUrlParameters"
      (pageChange)="onPageChange($event)"></app-dynamic-data-list-pagination>
    }
  </div>